/**
 * TNK-140 phase E — Figma surface treatment, scoped to the import
 * flow. Centralized so the four routes + the Quick View modal pull
 * from one palette without rewriting the global tailwind theme.
 *
 * Imported alongside `./fonts.css` which loads Cinzel + JetBrains Mono
 * via fontsource — those CSS @font-face declarations are global once
 * loaded; we just opt into them via `fontFamily` inline style on the
 * elements that want them.
 */

export const FIGMA = {
  // Page background — deeper than the app's default, gives the import
  // surface its own visual room.
  bg: "#080b14",

  // Panel surfaces (rest, hover) + borders.
  panel: "rgba(255,255,255,0.025)",
  panelHover: "rgba(255,255,255,0.04)",
  panelBorder: "rgba(255,255,255,0.07)",
  panelBorderHover: "rgba(255,255,255,0.1)",

  // Indigo system — the brand accent.
  indigo: "#6366f1",
  indigoDark: "#4f46e5",
  indigoLight: "#818cf8",
  indigoLighter: "#a5b4fc",
  indigoBg: "rgba(99,102,241,0.08)",
  indigoBgHover: "rgba(99,102,241,0.18)",
  indigoBorder: "rgba(99,102,241,0.22)",
  indigoBorderStrong: "rgba(99,102,241,0.45)",
  indigoGradient: "linear-gradient(135deg, #6366f1, #4f46e5)",
  indigoShadow: "0 8px 24px rgba(99,102,241,0.35)",
  indigoShadowHover: "0 10px 32px rgba(99,102,241,0.5)",

  // Confidence tones.
  good: "#4ade80",
  goodBg: "rgba(74,222,128,0.12)",
  goodBorder: "rgba(74,222,128,0.3)",
  warn: "#facc15",
  warnBg: "rgba(250,204,21,0.1)",
  warnBorder: "rgba(250,204,21,0.3)",
  bad: "#f87171",
  badBg: "rgba(248,113,113,0.08)",
  badBorder: "rgba(248,113,113,0.22)",

  // Text hierarchy — lightest to dimmest.
  fg: "#e8eaf0",
  fgSecondary: "#c0c8d8",
  muted: "#7a8aaa",
  dim: "#4a5568",
  veryDim: "#2a3550",

  // Fonts — loaded via fonts.css. Apply inline via `style.fontFamily`.
  fontHeading: "'Cinzel', serif",
  fontBody: "'Inter', system-ui, sans-serif",
  fontMono: "'JetBrains Mono', ui-monospace, monospace",
} as const;

export type FigmaPalette = typeof FIGMA;
